// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__3eYOv","section-1":"styles_section-1__dkHd4","content":"styles_content__BVI9n","section-2":"styles_section-2__5IFCL"};